import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useLanguage } from '../../i18n/LanguageContext';
import { FORM_FIELDS } from '../../i18n/sharedCopy';
import { getServices, submitContactInquiry } from '../../Utils/api';

export const SERVICE_INQUIRY_OTHER = 'Other';

function ContactInquiryForm({
  sourcePage,
  placeholders,
  submitClassName = 'readon more submit',
  submitLabel,
}) {
  const { locale, revision } = useLanguage();
  const [submitting, setSubmitting] = useState(false);
  const [services, setServices] = useState([]);

  useEffect(() => {
    let active = true;

    getServices()
      .then((data) => {
        if (!active) return;
        setServices((data || []).map((item) => ({ id: item.slug || item.id, title: item.title })));
      })
      .catch(() => {
        if (!active) return;
        setServices([]);
      });

    return () => {
      active = false;
    };
  }, [locale, revision]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (submitting) return;

    const form = event.currentTarget;
    const formData = new FormData(form);
    const payload = {
      name: String(formData.get('name') || '').trim(),
      email: String(formData.get('email') || '').trim(),
      phone: String(formData.get('phone') || '').trim(),
      serviceInquiry: String(formData.get('serviceInquiry') || '').trim(),
      message: String(formData.get('message') || '').trim(),
      sourcePage,
    };

    if (
      !payload.name ||
      !payload.email ||
      !payload.phone ||
      !payload.serviceInquiry ||
      !payload.message
    ) {
      toast.error('Please fill in all required fields.');
      return;
    }

    setSubmitting(true);
    try {
      await submitContactInquiry(payload);
      toast.success('Message sent successfully. We will get back to you soon.');
      form.reset();
    } catch {
      toast.error('Could not send your message. Please try again or email us directly.');
    } finally {
      setSubmitting(false);
    }
  };

  const serviceLabel = placeholders.service || FORM_FIELDS.service;
  const otherLabel = placeholders.other || FORM_FIELDS.other;

  return (
    <form id={`contact-form-${sourcePage}`} onSubmit={handleSubmit}>
      <fieldset disabled={submitting}>
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-6 mb-30">
            <input
              className="from-control"
              type="text"
              id={`name-${sourcePage}`}
              name="name"
              placeholder={placeholders.name}
              required
            />
          </div>
          <div className="col-lg-6 col-md-6 col-sm-6 mb-30">
            <input
              className="from-control"
              type="email"
              id={`email-${sourcePage}`}
              name="email"
              placeholder={placeholders.email}
              required
            />
          </div>
          <div className="col-lg-6 col-md-6 col-sm-6 mb-30">
            <input
              className="from-control"
              type="text"
              id={`phone-${sourcePage}`}
              name="phone"
              placeholder={placeholders.phone}
              required
            />
          </div>
          <div className="col-lg-6 col-md-6 col-sm-6 mb-30">
            <select
              className="from-control contact-inquiry-select"
              id={`service-${sourcePage}`}
              name="serviceInquiry"
              defaultValue=""
              required
            >
              <option value="" disabled>
                {serviceLabel}
              </option>
              {services.map((service) => (
                <option key={service.id} value={service.title}>
                  {service.title}
                </option>
              ))}
              <option value={SERVICE_INQUIRY_OTHER}>{otherLabel}</option>
            </select>
          </div>
          <div className="col-lg-12 mb-30">
            <textarea
              className="from-control"
              id={`message-${sourcePage}`}
              name="message"
              placeholder={placeholders.message}
              required
              defaultValue=""
            />
          </div>
        </div>
        <div className="btn-part">
          <div className="form-group mb-0">
            <input
              className={submitClassName}
              type="submit"
              value={submitting ? 'Sending...' : submitLabel}
            />
          </div>
        </div>
      </fieldset>
    </form>
  );
}

export default ContactInquiryForm;
